import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { FILTER__FORM_FIELDS_GLOBAL, getCreateUpdateReqBody, getUpdatedData } from './constants';
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import styles from '../../../studentTransfer/transferSetup/transferValidationConfig/styles.module.scss';
import ALoader from 'views/pages/manage/common/a-loader';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import FilterForm from './FilterForm';
import ListComponent from './ListComponent';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { getDropdownLabelsFromSelectArray, updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

const CashControlConfig = ({
  userPermissions,
  isBranchLevelConfig = false,
  dropdownData,
  setDropdownData,
  dropdownDataLoading
}) => {
  const isCreatePermission = checkPermission(userPermissions, "C");
  const isUpdatePermission = checkPermission(userPermissions, "U");

  const [loader, setLoader] = useState(false);
  const [rows, setRows] = useState([]);
  const history = useHistory();
  const listRef = useRef();
  const [filterForm, setFilterForm] = useState({ ...FILTER__FORM_FIELDS_GLOBAL });
  const [filterCount, setFilterCount] = useState(getFilterCount({ ...filterForm }));
  const [searchInput, setSearchInput] = useState("");

  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalPage: 0,
    totalRecords: 0,
  });
  const [currPageSize, setCurrentPageSize] = useState(50);

  const createUpdateHandler = async rowData => {
    try {
      setLoader(true);
      const { id } = rowData;
      let url = endpoint?.cashManagement?.cashControlConfig?.create;
      let method = "post";

      if (!rowData.isNew) {
        url = `${endpoint?.cashManagement?.cashControlConfig?.update}/${id}`;
        method = 'put';
      }

      const reqBody = getCreateUpdateReqBody(rowData, isBranchLevelConfig);
      const resp = await fetchAllPostPromisedData(url, reqBody, method);

      if (resp?.code === 200) {
        successToast(resp?.message);
        fetchList({}, paginationInfo?.currentPage, currPageSize, false, dropdownData);
      }

    } catch (e) {
      console.log(e);
    } finally {
      setLoader(false);
    }
  }

  const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, isFilterApplied = false, dropdowns = dropdownData) => {
    try {
      setLoader(true);
      const allBu = getDropdownLabelsFromSelectArray(dropdowns?.businessArea);

      if (!isFilterApplied) {
        reqObj = {
          ...reqObj,
          businessArea: isBranchLevelConfig ? allBu : ['ALL']
        }
      }

      const resp = await fetchAllPostPromisedData(
        `${endpoint?.cashManagement?.cashControlConfig?.search}?offset=${pageNumber}&pageSize=${pageSize}`,
        reqObj,
        "post"
      );

      if (resp?.code === 200) {
        const updatedData = getUpdatedData(resp, dropdownData);
        setRows(updatedData);
        setCurrentPageSize(pageSize);
        setPaginationInfo({
          currentPage: resp?.data?.currentPage,
          totalPage: resp?.data?.totalPage,
          totalRecords: resp?.data?.totalRecords,
        });
        listRef.current.stopEditing();
      }

    } catch (e) {
      console.log(e);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    Object.keys(dropdownData)?.length > 0 && fetchList()
  }, [dropdownData]);

  const nextButtonHandler = (newPage, currPageSize) => {
    const itemVal = updateRequest(filterForm);
    fetchList(itemVal, newPage, currPageSize, false, dropdownData);
  };

  const searchInputHandler = (value = searchInput) => {
    const req = {
      businessArea: value === "" ? [] : [value]
    }
    setFilterForm((prev) => ({ ...prev, searchByValue: value }));
    fetchList(req, 0, currPageSize, true, dropdownData)
  }

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchInputHandler();
    }
  };

  const handleOnUserInput = (value) => {
    setSearchInput(value);

    if (value === "" && value !== filterForm?.searchByValue)
      searchInputHandler(value);
  }

  const crossHandler = () => {
    setFilterForm((prev) => ({ ...prev, searchByValue: "" }));
    setSearchInput("");
    fetchList({}, 0, currPageSize, false, dropdownData);
  }

  const toggleStatusHandler = async rowData => {
    setLoader(true);
    setLoader(false);
  }

  return (
    <div className={`remove-container-top-space`}>
      {(dropdownDataLoading || loader) && (
        <ALoader position="fixed" />
      )}
      <div className={`${styles['page-container']}`}>
        <div className="d-flex justify-content-between align-items-start">
          <div className={`${styles['header-bar']}`}>
            <div className="ml-3 heading-4 color-dark">
              {isBranchLevelConfig
                ? 'BU Level Configuration'
                : 'PAN India Configuration'
              }
            </div>
          </div>

          <div className="d-flex justify-content-between">
            {isBranchLevelConfig &&
              <div style={{ width: "fit-content" }}>
                <AInput
                  style={{ width: '320px', height: '30px' }}
                  value={searchInput}
                  handler={handleOnUserInput}
                  crossIcon={true}
                  rightSearchIcon={true}
                  placeholder="Search by Business area"
                  searchIconClickHandler={(value) => { searchInputHandler() }}
                  onKeyDown={onKeyDownHandler}
                  crossHandler={crossHandler}

                />
              </div>
            }
            {isCreatePermission &&
              <AButton
                // updatedStyle={{ fontWeight: 600 }}
                onClick={() => listRef?.current?.addNewRow()}
                variant="primary_filled"
                size="xs"
              >
                + Add configuration
              </AButton>
            }
          </div>

        </div>
        <ListComponent
          currentPage={paginationInfo?.currentPage}
          currPageSize={currPageSize}
          ref={listRef}
          rows={rows}
          loader={loader}
          dropdown={dropdownData}
          setDropdownData={setDropdownData}
          createUpdateHandler={createUpdateHandler}
          nextButtonHandler={nextButtonHandler}
          rowCount={paginationInfo.totalRecords}
          isBranchLevelConfig={isBranchLevelConfig}
          toggleStatusHandler={toggleStatusHandler}
          isUpdatePermission={isUpdatePermission}
        />
      </div>
    </div>

  )
}

export default CashControlConfig;